/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReturnArrowIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <polyline points="1.5 8.785 4.5 13.285 8 9.285" />
      <path d="M4.506,13.285 C4.02,6.885 8.406,2.484 13.651,2.292 C18.893,2.098 23.301,6.192 23.493,11.436 C23.688,16.678 19.593,21.086 14.348,21.278" />
      <circle cx="14" cy="11.5" r="2" />
    </g>
  </svg>
);

export default ReturnArrowIcon;
